// extracted by mini-css-extract-plugin
module.exports = {"appBar":"customClasses_appBar__1M-KZ"};